module.exports = __webpack_public_path__ + "img/skipp-contract-modal.4ffb863a.svg";